import { getSessionId, getSessionStartTime, savePasskeyRegistrationCurrentStep, savePasskeyRegistrationTime, getAuthXToken } from '@/services/auth'
import { EMAIL_DOMAIN_SITEMINDER, NR_PASSKEY_REGISTRATION_START, NR_PASSKEY_REGISTRATION_STEP, NR_PASSKEY_REGISTRATION_STEPS } from './constants'

/**
 * Tracks passkey registration start step in New Relic and updates session state.
 * Records the step progression and calculates duration from session start.
 */
export const nrPasskeyRegistrationStart = (): boolean => {
  try {

    const authxToken = getAuthXToken()

    if (authxToken.payload.email.includes(EMAIL_DOMAIN_SITEMINDER)) {
      return false
    }

    const sessionId = getSessionId()
    const sessionStartTime = getSessionStartTime()

    const newrelic: any = (window as any).newrelic

    // Guard against invalid session start time
    if (!sessionStartTime || isNaN(Number(sessionStartTime))) {
      return false
    }

    const duration = Date.now() - Number(sessionStartTime)

    if (newrelic && sessionId) {
      newrelic.addPageAction(NR_PASSKEY_REGISTRATION_STEP, { sessionId, step: NR_PASSKEY_REGISTRATION_STEPS.PASSKEY_REGISTRATION_START })
      newrelic.addPageAction(NR_PASSKEY_REGISTRATION_START, { sessionId, durationMs: duration })
      savePasskeyRegistrationCurrentStep(NR_PASSKEY_REGISTRATION_STEPS.PASSKEY_REGISTRATION_START)
      savePasskeyRegistrationTime()
      return true
    }

    return false
  } catch {
    return false
  }
}
